/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as KioskRouteImport } from './routes/kiosk'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RoomRoomIdIndexRouteImport } from './routes/room/$roomId/index'

const KioskRoute = KioskRouteImport.update({
  id: '/kiosk',
  path: '/kiosk',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomRoomIdIndexRoute = RoomRoomIdIndexRouteImport.update({
  id: '/room/$roomId/',
  path: '/room/$roomId/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/kiosk': typeof KioskRoute
  '/room/$roomId/': typeof RoomRoomIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/kiosk': typeof KioskRoute
  '/room/$roomId': typeof RoomRoomIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/kiosk': typeof KioskRoute
  '/room/$roomId/': typeof RoomRoomIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/admin' | '/kiosk' | '/room/$roomId/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/admin' | '/kiosk' | '/room/$roomId'
  id: '__root__' | '/' | '/admin' | '/kiosk' | '/room/$roomId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  KioskRoute: typeof KioskRoute
  RoomRoomIdIndexRoute: typeof RoomRoomIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/kiosk': {
      id: '/kiosk'
      path: '/kiosk'
      fullPath: '/kiosk'
      preLoaderRoute: typeof KioskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/room/$roomId/': {
      id: '/room/$roomId/'
      path: '/room/$roomId'
      fullPath: '/room/$roomId/'
      preLoaderRoute: typeof RoomRoomIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  KioskRoute: KioskRoute,
  RoomRoomIdIndexRoute: RoomRoomIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
